/**
 * Welche Adresse jeder schreibende Handgriff ruft (8.1 Abschnitt 7, R1181,
 * R1182).
 *
 * **Das Recht steht nicht hier, sondern am Server** — an jedem Endpunkt, und
 * von dort kommt die Liste, mit der die Oberfläche weglässt, was der
 * Angemeldete nicht darf. Hier steht nur, welcher Handgriff welche Adresse
 * meint: `{}` an jeder Stelle, die erst beim Aufruf eingesetzt wird.
 *
 * **Diese Tabelle kann nicht still veralten:** Der Prüffall
 * `Rechte.test.tsx` liest jede schreibende Funktion aus `api.ts` und
 * meldet jede, die hier fehlt oder eine andere Adresse trägt — und jede
 * Adresse, die der Server nicht kennt.
 */
export const HANDGRIFFE = {
  rechnen: 'POST /api/abschluss/rechnen',
  anmelden: 'POST /api/anmeldung',
  abmelden: 'POST /api/abmeldung',
  kennwortWechseln: 'POST /api/anwender/kennwort',
  spielschalterSetzen: 'POST /api/anwender/ich/spiel',
  zahlendarstellungSetzen: 'POST /api/anwender/ich/zahlendarstellung',
  ueberwachungFestlegen: 'POST /api/arbeitsliste/ueberwachung',
  erfolgsmoment: 'POST /api/anwender/ich/erfolgsmoment',
  anwenderAnlegen: 'POST /api/anwender',
  anwenderPflegen: 'POST /api/anwender/{}',
  freigeben: 'POST /api/laeufe/{}/freigabe',
  // Die Handgriffe am Schloss (2.13 Abschnitt 20.7, R1690–R1693).
  periodeSchliessen: 'POST /api/abschluss/periodenschluss/schliessen',
  periodeWiedereroeffnen: 'POST /api/abschluss/periodenschluss/wiedereroeffnen',
  freigabeZuruecknehmen: 'POST /api/abschluss/freigabe/zuruecknahme',
  buchen: 'POST /api/erfassung',
  belegAendern: 'POST /api/erfassung/{}/aendern',
  belegreihenfolge: 'POST /api/journal/ordner/{}/reihenfolge',
  umkehren: 'POST /api/erfassung/{}/umkehren',
  belegLoeschen: 'DELETE /api/erfassung/{}',
  ordnerVerschieben: 'POST /api/journal/ordner/{}/verschieben',
  ordnerAnlegen: 'POST /api/journal/ordner',
  ordnerUmbenennen: 'POST /api/journal/ordner/{}/umbenennen',
  ordnerLoeschen: 'DELETE /api/journal/ordner/{}',
  belegAblegen: 'POST /api/journal/ablage',
  stammdatumAnlegen: 'POST /api/stammdaten/{}',
  aussondern: 'POST /api/stammdaten/{}/{}/aussondern',
  abbildungSpeichern: 'POST /api/datenimport/quellen/{}/abbildung',
  dateiprobe: 'POST /api/datenimport/probe',
  datenimportLoeschen: 'POST /api/datenimport/staende/{}/loeschen',
  importvorschau: 'POST /api/datenimport/vorschau',
  packagevorschau: 'POST /api/datenimport/package/vorschau',
  packageUebernehmen: 'POST /api/datenimport/package/uebernehmen',
  packagevorlageVorschau: 'POST /api/datenimport/packagevorlage/vorschau',
  packagevorlageHolen: 'POST /api/datenimport/packagevorlage',
  stapelvorschau: 'POST /api/datenimport/stapel/vorschau',
  stapelUebernehmen: 'POST /api/datenimport/stapel/uebernehmen',
  datenimportAusAufbewahrung: 'POST /api/datenimport/staende/{}/vorschau',
  aktualisierungsvorschau: 'POST /api/datenimport/aktualisierung/vorschau',
  aktualisierungUebernehmen: 'POST /api/datenimport/aktualisierung/uebernehmen',
  stammdatenVorschau: 'POST /api/stammdaten/austausch/vorschau',
  stammdatenUebernehmen: 'POST /api/stammdaten/austausch/uebernahme',
  zuordnen: 'POST /api/datenimport/mapping',
  zuordnungStilllegen: 'POST /api/datenimport/mapping/{}/stilllegen',
  zuordnungInKraftSetzen: 'POST /api/datenimport/mapping/{}/inkraft',
  bewegungsartZuordnen: 'POST /api/datenimport/bewegungsartmapping',
  bewegungsartErzeugen: 'POST /api/datenimport/bewegungsart',
  wertZuordnen: 'POST /api/datenimport/wertzuordnung',
  wertErzeugen: 'POST /api/datenimport/wert',
  wertzuordnungStilllegen: 'POST /api/datenimport/wertzuordnung/{}/stilllegen',
  wertzuordnungInKraftSetzen: 'POST /api/datenimport/wertzuordnung/{}/inkraft',
  bewegungsartzuordnungStilllegen: 'POST /api/datenimport/bewegungsartmapping/{}/stilllegen',
  bewegungsartzuordnungInKraftSetzen: 'POST /api/datenimport/bewegungsartmapping/{}/inkraft',
  schichtAnlegen: 'POST /api/ledgeraufbau/anlegen',
  schichtAufnehmen: 'POST /api/ledgeraufbau/aufnehmen',
  schichtAushaengen: 'POST /api/ledgeraufbau/aushaengen',
  schichtVerschieben: 'POST /api/ledgeraufbau/verschieben',
  schichtBenennen: 'POST /api/ledgeraufbau/benennen',
  positionUmhaengen: 'POST /api/gliederung/position',
  kontoUmhaengen: 'POST /api/gliederung/konto',
  kontoAushaengen: 'POST /api/gliederung/konto/aushaengen',
  stichtagskursanpassungSetzen: 'POST /api/konten/{}/stichtagskursanpassung',
  kontogruppeSetzen: 'POST /api/gliederung/konto/gruppe',
  positionEinfuegen: 'POST /api/gliederung/einfuegen',
  kontoAnlegen: 'POST /api/gliederung/konto-anlegen',
  kfrZeileAnlegen: 'POST /api/kfr/zeile-anlegen',
  statistikkontoAnlegen: 'POST /api/kfr/statistikkonto-anlegen',
  kfrZeileLoeschen: 'POST /api/kfr/zeile-loeschen',
  reihenfolgeSetzen: 'POST /api/reihenfolge',
  unterpositionAnlegen: 'POST /api/gliederung/unterposition',
  kontoErzeugen: 'POST /api/datenimport/konto',
  importUebernehmen: 'POST /api/datenimport/uebernehmen',
  zweckPflegen: 'POST /api/stammdaten/{}/zweck/{}',
  stammdatumPflegen: 'POST /api/stammdaten/{}/{}',
  stammdatumEinordnen: 'POST /api/stammdaten/{}/{}/einordnen',
  konzernabschlussAnlegen: 'POST /api/abschluss/konzernabschluesse',
  konzernabschlussAnstossen: 'POST /api/abschluss/konzernabschluesse/{}/rechnen',
  konsolidierungsschrittPflegen: 'POST /api/abschluss/schritte',
  konsolidierungsschrittUebersteuern: 'POST /api/abschluss/schritte/{}/uebersteuerung',
  konsolidierungsschrittAbgrenzen: 'POST /api/abschluss/schritte/{}/abgrenzung',
  konsolidierungsschrittKorrigieren: 'POST /api/abschluss/schritte/{}/ausweiskorrektur',
  konsolidierungsschrittEntfernen: 'DELETE /api/abschluss/schritte/{}',
  konzernhandbuchPflegen: 'POST /api/abschluss/konzernhandbuch',
  konzernhandbuchEntfernen: 'DELETE /api/abschluss/konzernhandbuch/{}',
  kurstabelleAnlegen: 'POST /api/kurse/tabelle',
  kursSetzen: 'POST /api/kurse/zeile',
  kursZuruecknehmen: 'POST /api/kurse/zeile/zuruecknehmen',
  kursdatei: 'POST /api/kurse/datei',
  kurseUebernehmen: 'POST /api/kurse/uebernehmen',
  historischeKurseAnlegen: 'POST /api/historische-kurse/anlegen',
  historischerKursSetzen: 'POST /api/historische-kurse/zeile',
  zeitachseSetzen: 'POST /api/perioden/zeitachse',
  pruefregelFestlegen: 'POST /api/pruefregeln',
} as const

/** Der Name eines schreibenden Handgriffs — wie die Funktion in `api.ts` heißt. */
export type Handgriffname = keyof typeof HANDGRIFFE
